























import { creteOrUpdateSmsTag } from '@/api/Sms/sms.api'
import CreateDialog from '@/components/CreateDialog.vue'
import PhoneTextField from '@/components/PhoneTextField.vue'
import { VueForm } from '@/utils/interfaces'
import { crudMixin } from '@/utils/mixins/crudMixin'
import { editMixin } from '@/utils/mixins/editMixin'
import mixins from 'vue-typed-mixins'

export default mixins(crudMixin, editMixin).extend({
  components: { appCreateDialog: CreateDialog, PhoneTextField },
  data() {
    return {
      rules: {
        required: (v: string) => !!v || this.$t('validation.field-required'),
      },
      crud: {
        name: '',
      },
      defaultCrud: {
        name: '',
      },
      loading: false,
    }
  },
  methods: {
    async onSuccess() {
      const form = this.$refs.form as VueForm
      if (!form.validate()) return
      try {
        this.loading = true
        const response = await creteOrUpdateSmsTag(this.crud)
        this.$emit('new-item', response.data)
        this.$emit('input', false)
      } finally {
        this.loading = false
      }
    },
  },
})
